import { Link } from 'react-router-dom';
import { useCustomers } from '../api/hooks';
import { DraftBanner } from '../components/DraftBanner';

export function CustomersPage() {
  const customers = useCustomers();

  return (
    <>
      <div className="page-head">
        <h1>Customers</h1>
        <Link className="btn primary" to="/customers/new">
          Add Customer
        </Link>
      </div>
      <DraftBanner kind="customer" to="/customers/new" label="customer" />
      <div className="card">
        {customers.isLoading && <p className="muted">Loading…</p>}
        {customers.data && customers.data.length === 0 && <p className="muted">No customers created in the app yet.</p>}
        {customers.data && customers.data.length > 0 && (
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>QuickBooks Id</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {customers.data.map((c) => (
                  <tr key={c.id}>
                    <td>{c.displayName ?? c.localRef}</td>
                    <td>{c.qboId ?? '—'}</td>
                    <td>{c.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <p className="muted" style={{ fontSize: '0.8rem', marginTop: '0.75rem' }}>
          These are customers created through this app (also created automatically when used on a quote).
        </p>
      </div>
    </>
  );
}
